export default {
  methods: {
    parseCurrency(value) {
      let currency = value.toFixed(2).split('.')
      currency[0] = currency[0].split(/(?=(?:...)*$)/).join('.')

      return `R$ ${currency.join(',')}`
    }
  }
}
